import React from "react";
import { Fab as MUIFab } from "@mui/material";
import { useApp } from "context";
import AddIcon from "@mui/icons-material/Add";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import FilterAltIcon from "@mui/icons-material/FilterAlt";

type Props = {
  sx?: any;
  variant?: "add" | "edit" | "delete" | "filter";
  onClick?: () => void;
  children?: React.ReactNode;
};

export const Fab = (props: Props) => {
  const { t, theme } = useApp();

  const icon = (() => {
    const mr = theme.margin.xs;
    switch (props.variant) {
      case "add":
        return <AddIcon sx={{ mr }} />;
      case "edit":
        return <EditIcon sx={{ mr }} />;
      case "delete":
        return <DeleteIcon sx={{ mr }} />;
      case "filter":
        return <FilterAltIcon sx={{ mr }} />;
    }
    return null;
  })();

  const text = (() => {
    switch (props.variant) {
      case "add":
        return t.action.add;
      case "edit":
        return t.action.edit;
      case "delete":
        return t.action.delete;
      case "filter":
        return t.action.filter;
    }
    return null;
  })();

  return (
    <MUIFab
      variant="extended"
      sx={{
        position: "fixed",
        color: theme.color.primary.text,
        backgroundColor: theme.color.primary.color,
        right: theme.margin.md * theme.margin.factor,
        bottom: theme.margin.lg * theme.margin.factor,
        ...props.sx,
        "&:hover": {
          backgroundColor: theme.color.primary.color,
        },
      }}
      onClick={props.onClick}
    >
      {props.children ? (
        props.children
      ) : (
        <>
          {icon} {text}
        </>
      )}
    </MUIFab>
  );
};
